import type { ProgressBarVariant } from './types';

export const clampPercentage = (percentage: number): number => {
  return Math.min(100, Math.max(0, percentage));
};

export const getProgressBarLabel = (label: string, clampedPercentage: number): string => {
  return label || `${clampedPercentage}% completed`;
};

export const progressLineHeightClassNames: Record<ProgressBarVariant, string> = {
  compact: 'h-2',
  default: 'h-4'
};

export const chartHeightConfig: Record<ProgressBarVariant, string> = {
  compact: 'h-2',
  default: 'h-4'
};
